/**
 * PanelField — Navy 面板表单字段（共享组件）
 *
 * 支持 input / select / textarea 三种类型，用于 ClientDetail / ContactDetail / ProjectDetail 左侧 Navy 面板。
 */
export default function PanelField({ label, value, onChange, type = 'text', options, placeholder }) {
  return (
    <div className="mb-3">
      <label className="block text-xs font-semibold uppercase tracking-wider mb-1" style={{ color: '#c9a84c' }}>
        {label}
      </label>
      {type === 'select' ? (
        <select
          value={value || ''}
          onChange={e => onChange?.(e.target.value)}
          className="w-full px-2 py-1.5 text-sm rounded border-0 focus:ring-1 focus:ring-[#c9a84c]"
          style={{ background: 'rgba(255,255,255,0.08)', color: '#f8f7f4' }}
        >
          {options.map(o => <option key={o.value} value={o.value} style={{ background: '#1a1a2e', color: '#f8f7f4' }}>{o.label}</option>)}
        </select>
      ) : type === 'textarea' ? (
        <textarea
          value={value || ''}
          onChange={e => onChange?.(e.target.value)}
          rows={3}
          placeholder={placeholder}
          className="w-full px-2 py-1.5 text-sm rounded border-0 resize-none focus:ring-1 focus:ring-[#c9a84c]"
          style={{ background: 'rgba(255,255,255,0.08)', color: '#f8f7f4' }}
        />
      ) : (
        <input
          type={type}
          value={value || ''}
          onChange={e => onChange?.(e.target.value)}
          placeholder={placeholder}
          className="w-full px-2 py-1.5 text-sm rounded border-0 focus:ring-1 focus:ring-[#c9a84c]"
          style={{ background: 'rgba(255,255,255,0.08)', color: '#f8f7f4' }}
        />
      )}
    </div>
  );
}
